import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const PRUEBAS = [
  {
    id: "editor",
    label: "Editor Key Frame",
    description: "Reconstruye o edita zonas de una imagen con IA",
    path: "/keyframes/editor",
    active: true,
  },
  {
    id: "image-composer",
    label: "Image Composer",
    description: "Compón imágenes combinando elementos y escenas con IA",
    path: "/keyframes/image-composer",
    active: true,
  },
  {
    id: "lab",
    label: "Generador Lab",
    description: "Experimenta con todos los parámetros de generación y compara resultados",
    path: "/keyframes/lab",
    active: true,
  },
  {
    id: "facemaker",
    label: "Face Maker",
    description: "Genera fichas de personaje con 6 propuestas en una sola imagen (Claude + Nano Banana Pro)",
    path: "/keyframes/facemaker",
    active: true,
  },
];

export default function PruebasMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const activePrueba = PRUEBAS.find((t) => location.pathname.startsWith(t.path));

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (item) => {
    if (!item.active) return;
    setOpen(false);
    navigate(item.path);
  };

  return (
    <div className="tools-menu" ref={ref}>
      <button
        className={`tools-menu-trigger ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span className="tools-menu-label" style={{ color: "#ff9f43" }}>En Desarrollo</span>
        {activePrueba && <span className="tools-menu-current">{activePrueba.label}</span>}
        <span className="tools-menu-chevron">{open ? "\u25B4" : "\u25BE"}</span>
      </button>

      {open && (
        <div className="tools-menu-dropdown">
          {PRUEBAS.map((item) => (
            <div
              key={item.id}
              className={`tools-menu-item ${activePrueba?.id === item.id ? "active" : ""} ${!item.active ? "disabled" : ""}`}
              onClick={() => select(item)}
            >
              <div className="tools-menu-item-label">
                {item.label}
                {!item.active && <span className="tools-soon-badge">pronto</span>}
              </div>
              <div className="tools-menu-item-desc">{item.description}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
